import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@zurich/ui/legacy/utils';
import { Indicator } from './Indicator';
export const IndicatorGroup = ({ indicatorEntry }) => (_jsx(IndicatorGroupStyled, { children: indicatorEntry.map((indicator, index) => !indicator.hide && (_jsx(Indicator, { iconVariant: indicator.iconVariant, primaryButtonLabel: indicator.primaryButtonLabel, indicatorTitle: indicator.indicatorTitle, isWarning: indicator.isWarning, onClick: indicator.onClick, children: indicator.dialogContent }, index))) }));
const IndicatorGroupStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
        justifyContent: 'flex-start',
        margin: theme.spacing(0, -1),
    },
}));
export default IndicatorGroup;
